import React from 'react';
// CANVAS
import Card from "canvas-core-react/lib/Card";
// COMPONENTS
import BlackBanner from './BlackBanner';
import BenefitsBanner from '../BenefitsBanner/BenefitsBanner';
import InfoBanner from '../InfoBanner/InfoBanner';

const Layout = ({ children, idBlackBanner, withoutCard = false, navButtons, twoNavButtons = false, showBanner = true }) => {
	const withOneOrTwoButtons = twoNavButtons ? 'LayoutButtons_withTwo' : '';
	const claseButtons = `LayoutButtons_container ${withOneOrTwoButtons}`;
	return (
		<>
			<BlackBanner idBlackBanner={idBlackBanner} />
			<div className="LayoutBody_container">
				<div className="LayoutBody_content">
					{withoutCard ? children : (
						<Card className='LayoutCard' type='floatLow'>
							{children}
						</Card>
					)}
					{
						navButtons ? (
							<div className={claseButtons}>{navButtons}</div>
						) : null
					}
				</div>
				{showBanner == true &&
					<>
						<BenefitsBanner />
						<InfoBanner />
					</>
				}
			</div>
		</>
	);
}
export default Layout;